<template>
  <div class="student-page">
    <!-- 查询区域 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="账号">
          <el-input v-model="searchForm.username" placeholder="请输入账号" clearable />
        </el-form-item>

        <el-form-item label="姓名">
          <el-input v-model="searchForm.realName" placeholder="请输入姓名" clearable />
        </el-form-item>

        <el-form-item label="科目">
          <el-select
              v-model="searchForm.subjectMappingId"
              placeholder="请选择科目"
              clearable
              filterable
          >
            <el-option
                v-for="item in subjectOptions"
                :key="item.id"
                :label="item.subjectName"
                :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
              v-model="searchForm.createTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card">
      <div slot="header" class="table-header">
        <span>学员管理</span>
        <el-button type="primary" size="small" @click="openAddDialog">新增学员</el-button>
      </div>

      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="username" label="账号" min-width="180" />
        <el-table-column prop="realName" label="姓名" min-width="120" />
        <el-table-column label="所属科目" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.subjectName || '-' }}
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="lastLoginTime" label="最后登录时间" min-width="180" />
        <el-table-column prop="createTime" label="创建时间" min-width="180" />

        <el-table-column label="操作" width="320" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleViewLearning(scope.row)">学习情况</el-button>
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleStatusChange(scope.row)">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" @click="handleResetPassword(scope.row)">重置密码</el-button>
            <el-button type="text" style="color:red" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        />
      </div>
    </el-card>

    <!-- 新增学员 -->
    <el-dialog title="新增学员" :visible.sync="addDialogVisible" width="500px" @close="resetAddForm">
      <el-form ref="addFormRef" :model="addForm" :rules="addRules" label-width="100px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="addForm.username" />
        </el-form-item>

        <el-form-item label="姓名" prop="realName">
          <el-input v-model="addForm.realName" />
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" show-password />
        </el-form-item>

        <el-form-item label="所属科目" prop="subjectMappingId">
          <el-select v-model="addForm.subjectMappingId" placeholder="请选择科目" clearable>
            <el-option
                v-for="item in subjectOptions"
                :key="item.id"
                :label="item.subjectName"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddStudent">确定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑学员 -->
    <el-dialog title="编辑学员" :visible.sync="editDialogVisible" width="500px" @close="resetEditForm">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="账号">
          <el-input v-model="editForm.username" disabled />
        </el-form-item>

        <el-form-item label="姓名" prop="realName">
          <el-input v-model="editForm.realName" />
        </el-form-item>

        <el-form-item label="所属科目" prop="subjectMappingId">
          <el-select v-model="editForm.subjectMappingId" placeholder="请选择科目" clearable>
            <el-option
                v-for="item in subjectOptions"
                :key="item.id"
                :label="item.subjectName"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditStudent">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentList,
  addStudent,
  updateStudent,
  updateStudentStatus,
  resetStudentPassword,
  deleteStudent
} from '@/api/admin/student'
import { getSubjectMappingOptions } from '@/api/admin/subjectMapping'

export default {
  name: 'AdminStudent',
  data() {
    return {
      loading: false,
      tableData: [],
      subjectOptions: [],

      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },

      searchForm: {
        username: '',
        realName: '',
        subjectMappingId: null,
        status: null,
        createTimeRange: []
      },

      addDialogVisible: false,
      addForm: {
        username: '',
        realName: '',
        password: '',
        subjectMappingId: null
      },

      addRules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        subjectMappingId: [{ required: true, message: '请选择科目', trigger: 'change' }]
      },

      editDialogVisible: false,
      editForm: {
        id: null,
        username: '',
        realName: '',
        subjectMappingId: null,
        status: null
      },

      editRules: {
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        subjectMappingId: [{ required: true, message: '请选择科目', trigger: 'change' }]
      }
    }
  },

  created() {
    this.loadSubjectOptions()
    this.loadStudentList()
  },

  methods: {
    async loadSubjectOptions() {
      try {
        const res = await getSubjectMappingOptions()
        if (res.code === 200) {
          this.subjectOptions = res.data || []
        } else {
          this.$message.error(res.message || '获取科目列表失败')
        }
      } catch (e) {
        this.$message.error('获取科目列表失败')
      }
    },

    async loadStudentList() {
      this.loading = true
      try {
        const params = {
          username: this.searchForm.username,
          realName: this.searchForm.realName,
          subjectMappingId: this.searchForm.subjectMappingId,
          status: this.searchForm.status,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }

        if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
          params.createTimeStart = this.searchForm.createTimeRange[0]
          params.createTimeEnd = this.searchForm.createTimeRange[1]
        }

        const res = await getStudentList(params)

        if (res.code === 200) {
          this.tableData = res.data.records || []
          this.pagination.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '获取学员列表失败')
        }
      } catch (e) {
        this.$message.error('获取学员列表失败')
      } finally {
        this.loading = false
      }
    },

    handleViewLearning(row) {
      this.$router.push({
        path: '/admin/student/learning-detail',
        query: { id: row.id }
      })
    },

    handleSearch() {
      this.pagination.pageNum = 1
      this.loadStudentList()
    },

    handleReset() {
      this.searchForm = {
        username: '',
        realName: '',
        subjectMappingId: null,
        status: null,
        createTimeRange: []
      }
      this.pagination.pageNum = 1
      this.loadStudentList()
    },

    handleCurrentChange(pageNum) {
      this.pagination.pageNum = pageNum
      this.loadStudentList()
    },

    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageNum = 1
      this.loadStudentList()
    },

    openAddDialog() {
      this.addDialogVisible = true
    },

    resetAddForm() {
      this.addForm = {
        username: '',
        realName: '',
        password: '',
        subjectMappingId: null
      }
      this.$nextTick(() => {
        if (this.$refs.addFormRef) {
          this.$refs.addFormRef.clearValidate()
        }
      })
    },

    submitAddStudent() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return

        try {
          const res = await addStudent(this.addForm)
          if (res.code === 200) {
            this.$message.success('新增成功')
            this.addDialogVisible = false
            this.loadStudentList()
          } else {
            this.$message.error(res.message || '新增失败')
          }
        } catch (e) {
          this.$message.error('新增失败')
        }
      })
    },

    handleEdit(row) {
      this.editForm = {
        id: row.id,
        username: row.username,
        realName: row.realName,
        subjectMappingId: row.subjectMappingId,
        status: row.status
      }
      this.editDialogVisible = true
    },

    resetEditForm() {
      this.editForm = {
        id: null,
        username: '',
        realName: '',
        subjectMappingId: null,
        status: null
      }
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate()
        }
      })
    },

    submitEditStudent() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return

        try {
          const res = await updateStudent(this.editForm)
          if (res.code === 200) {
            this.$message.success('编辑成功')
            this.editDialogVisible = false
            this.loadStudentList()
          } else {
            this.$message.error(res.message || '编辑失败')
          }
        } catch (e) {
          this.$message.error('编辑失败')
        }
      })
    },

    handleStatusChange(row) {
      const targetStatus = row.status === 1 ? 0 : 1
      const text = targetStatus === 1 ? '启用' : '禁用'

      this.$confirm(`确定要${text}该学员吗？`, '提示', { type: 'warning' })
          .then(async () => {
            try {
              const res = await updateStudentStatus({
                id: row.id,
                status: targetStatus
              })
              if (res.code === 200) {
                this.$message.success(`${text}成功`)
                this.loadStudentList()
              } else {
                this.$message.error(res.message || `${text}失败`)
              }
            } catch (e) {
              this.$message.error(`${text}失败`)
            }
          })
          .catch(() => {})
    },

    handleResetPassword(row) {
      this.$confirm(`确定要重置学员【${row.username}】的密码吗？`, '提示', { type: 'warning' })
          .then(async () => {
            try {
              const res = await resetStudentPassword(row.username)
              if (res.code === 200) {
                this.$message.success('密码已重置为 123456')
              } else {
                this.$message.error(res.message || '重置密码失败')
              }
            } catch (e) {
              this.$message.error('重置密码失败')
            }
          })
          .catch(() => {})
    },

    handleDelete(row) {
      this.$confirm(
          `确定要彻底删除学员【${row.username}】吗？删除后该学员的练习、考试、错题等相关数据都会被一并删除，且不可恢复。`,
          '危险操作提示',
          {
            type: 'warning',
            confirmButtonText: '确认删除',
            cancelButtonText: '取消'
          }
      ).then(async () => {
        try {
          const res = await deleteStudent(row.id)
          if (res.code === 200) {
            this.$message.success('删除成功')
            if (this.tableData.length === 1 && this.pagination.pageNum > 1) {
              this.pagination.pageNum--
            }
            this.loadStudentList()
          } else {
            this.$message.error(res.message || '删除失败')
          }
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.student-page {
  width: 100%;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-box {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>